// 上传管理
export default [
  {
    path: "/upload",
    meta: { title: "上传/下载管理" },
    component: () => import("../views/upload/index"),
    children: [
      {
        path: "/upload/uploadList",
        meta: { title: "上传/下载列表", isMenu: true },
        component: () => import("../views/upload/uploadList"),
      },
    ],
  },
]
